/**
 * GTM dataLayer utilities for web reservation.
 */

type GtmUserData = {
  email?: string
  phone?: string
  country?: string
}

type GtmTreatmentItem = {
  treatment_id?: string
  department_name?: string
  starts_at?: string
  ends_at?: string
  is_first?: boolean
}

type GtmReservationCompleteEvent = {
  event: 'march_reservation_complete'
  medical_business_id?: string
  clinic_id?: string
  inflow_id?: string
  treatment?: GtmTreatmentItem
  user?: GtmUserData
}

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[]
  }
}

export function pushReservationCompleteEvent(
  params: GtmReservationCompleteEvent
): void {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(params)
}
